import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmf = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 7.25C15.4142 7.25 15.75 7.58579 15.75 8V14C15.75 14.4142 15.4142 14.75 15 14.75C14.5858 14.75 14.25 14.4142 14.25 14V8C14.25 7.58579 14.5858 7.25 15 7.25Z",
		fill: "#646060"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17 2C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H13C11.3431 22 10 20.6569 10 19H6C5.44772 19 5 18.5523 5 18V16.8252C3.83548 16.413 3 15.3057 3 14V6C3 4.34315 4.34315 3 6 3C6.88738 3 7.68219 3.3876 8.23145 4H10.1738C10.5859 2.83532 11.6941 2 13 2H17ZM13 4C12.4477 4 12.001 4.44772 12.001 5L12 19C12 19.5523 12.4477 20 13 20H17C17.5523 20 18 19.5523 18 19V5C18 4.44772 17.5523 4 17 4H13ZM9 14C9 15.3057 8.16452 16.413 7 16.8252V17H10V6H9V14ZM6 5C5.44772 5 5 5.44772 5 6V14C5 14.5523 5.44772 15 6 15C6.55228 15 7 14.5523 7 14V6C7 5.44772 6.55228 5 6 5Z",
		fill: "#646060"
	})]
});
export default SvgAmf;
